import React from "react";
// Swiper
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination, A11y } from "swiper";
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import "swiper/css/a11y";
// Motion
import { motion } from "framer-motion";
// Helmet (meta + JSON-LD)
import { Helmet } from "react-helmet-async";

export const Testimonial = () => {
  // ✅ Limpio textos y tildes; quito espacios sobrantes en URLs
  const testimonials = [
    {
      image:
        "https://img.freepik.com/foto-gratis/estilo-vida-emociones-gente-concepto-casual-confiado-agradable-sonriente-mujer-asiatica-brazos-cruzados-pecho-seguro-listo-ayudar-escuchando-companeros-trabajo-participando-conversacion_1258-59335.jpg?uid=R173083927&ga=GA1.1.1759052710.1733761302&semt=ais_hybrid",
      message: "¡Excelente servicio! Altamente recomendado.",
      name: "María Arellano",
      occupation: "Gerente General, MBC",
      ratingValue: 5
    },
    {
      image:
        "https://img.freepik.com/foto-gratis/hombre-negocios-sonriente-tablet_1098-651.jpg?uid=R173083927&ga=GA1.1.1759052710.1733761302&semt=ais_hybrid",
      message:
        "Ernesto y su equipo tienen un nivel técnico sobresaliente. Mejoramos procesos de seguridad.",
      name: "Roberto Maza",
      occupation: "Gerente General, RMC",
      ratingValue: 5
    },
    {
      image:
        "https://img.freepik.com/foto-gratis/hombre-negocios-experimentado-pie-sala-oficina-empleado-oficina-contenido-indio-anteojos-sonriendo-posando-manos-juntas-concepto-negocio-gestion-corporacion_74855-11681.jpg?uid=R173083927&ga=GA1.1.1759052710.1733761302&semt=ais_hybrid",
      message: "Profesionalismo y calidad en cada detalle.",
      name: "Éder Martínez",
      occupation: "CEO, Naviera BC International",
      ratingValue: 5
    },
    {
      image:
        "https://img.freepik.com/foto-gratis/confianza-empresaria-positiva-vistiendo-traje-formal-gafas-pie-brazos-cruzados-sonriendo_74855-10329.jpg?uid=R173083927&ga=GA1.1.1759052710.1733761302&semt=ais_hybrid",
      message: "Excelente experiencia; superaron mis expectativas.",
      name: "Lila Calle",
      occupation: "CEO, Melbourne Company",
      ratingValue: 5
    },
    {
      image:
        "https://img.freepik.com/foto-gratis/hombre-angulo-que-trabaja-computadora-portatil_23-2148479521.jpg?uid=R173083927&ga=GA1.1.1759052710.1733761302&semt=ais_hybrid",
      message: "Me encantó el soporte bilingüe para el equipo.",
      name: "José Castaño",
      occupation: "CEO, UTB Logistic",
      ratingValue: 5
    }
  ];

  // ✅ JSON-LD: Organization con reviews (elegible a rich results)
  const reviewsSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    "name": "ESGRYMA Consulting Group",
    "url": "https://esgrymaconsulting.com/",
    "review": testimonials.map((t) => ({
      "@type": "Review",
      "reviewBody": t.message,
      "author": { "@type": "Person", "name": t.name },
      "itemReviewed": { "@type": "Person", "name": "Ernesto Mora" },
      "reviewRating": {
        "@type": "Rating",
        "ratingValue": String(t.ratingValue),
        "bestRating": "5",
        "worstRating": "1"
      }
    }))
  };

  return (
    <motion.section
      initial={{ opacity: 0, y: 24 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, amount: 0.2 }}
      className="bg-black text-white py-16"
      role="region"
      aria-label="Testimonios de clientes sobre consultoría en SST e IA"
    >
      <Helmet>
        <title>Testimonios | Consultoría en SST e IA — Ernesto Mora</title>
        <meta
          name="description"
          content="Opiniones reales de clientes que han mejorado su Seguridad y Salud en el Trabajo con consultoría y formación en IA aplicada."
        />
        <script type="application/ld+json">{JSON.stringify(reviewsSchema)}</script>
      </Helmet>

      <div className="container mx-auto px-8 max-w-4xl">
        {/* H2 con keyword */}
        <h2 className="text-3xl lg:text-5xl font-bold text-center mb-3">
          Testimonios de clientes
        </h2>
        <p className="text-center text-gray-300 mb-10">
          Resultados en <strong>SST</strong> e <strong>IA aplicada</strong> que
          aumentan productividad y reducen incidentes en LATAM.
        </p>

        <Swiper
          modules={[Navigation, Pagination, A11y]}
          navigation
          pagination={{ clickable: true }}
          a11y={{ enabled: true }}
          spaceBetween={30}
          aria-label="Carrusel de testimonios"
        >
          {testimonials.map(({ image, message, name, occupation }, i) => (
            <SwiperSlide key={`${name}-${i}`}>
              {/* Usamos figure/blockquote para semántica */}
              <figure className="flex flex-col items-center gap-6 text-center lg:flex-row lg:text-left lg:gap-10 p-6 bg-gray-800 rounded-lg">
                <div className="w-24 h-24 lg:w-32 lg:h-32 rounded-full overflow-hidden border-4 border-gray-600 lg:ml-10 flex-shrink-0">
                  <img
                    src={image}
                    alt={`${name}, ${occupation}`}
                    className="w-full h-full object-cover"
                    loading="lazy"
                    decoding="async"
                    width="128"
                    height="128"
                  />
                </div>

                <figcaption className="flex-1">
                  <blockquote className="text-xl lg:text-2xl italic leading-relaxed">
                    “{message}”
                  </blockquote>
                  <div className="mt-6">
                    <h3 className="text-lg font-bold">{name}</h3>
                    <span className="text-sm text-gray-400">{occupation}</span>
                  </div>
                </figcaption>
              </figure>
            </SwiperSlide>
          ))}
        </Swiper>

        {/* Fallback para SEO si JS estuviera deshabilitado */}
        <noscript>
          <ul>
            {testimonials.map((t, i) => (
              <li key={`noscript-${i}`}>
                <strong>{t.name}</strong> — {t.occupation}: {t.message}
              </li>
            ))}
          </ul>
        </noscript>
      </div>
    </motion.section>
  );
};

export default Testimonial;
